/**
 * 轉換 語言代號=>語言縮寫
 * @param {number} langCode
 */
export const langCodeToString = (langCode) => {
  switch (langCode) {
    case 1:
      return 'zh'
    case 2:
      return 'en'
    case 3:
      return 'ja'
    case 4:
      return 'ko'
    default:
      throw Error(`langCode error ${langCode}`)
  }
}

/**
 * 轉換 語言縮寫=>語言代號
 * @param {string} langString
 */
export const langStringToCode = (langString) => {
  switch (langString) {
    case 'zh':
      return 1
    case 'en':
      return 2
    case 'ja':
      return 3
    case 'ko':
      return 4
    default:
      throw Error(`langCode error ${langString}`)
  }
}

/**
 * 轉換 語言縮寫=>語言名稱
 * @param {string} langString
 */
export const langStringToFullLangName = (langString) => {
  switch (langString) {
    case 'zh':
      return '繁體中文'
    case 'en':
      return 'English'
    case 'ja':
      return '日本語'
    case 'ko':
      return '한국어'
    default:
      throw Error(`langCode error ${langString}`)
  }
}

/**
 * 轉換 國家代號=>語言名稱
 * @param {number} countryCode 
 */
export const countryCodeToCode = (countryCode) => {
  switch (countryCode) {
    case 1:
      return 'zh';
    case 3:
      return 'ja';
    case 4:
      return 'ko';
    default:
      return 'en';
  }
}

